/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './ListExpandable.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

type TypeListRow = {
  text: string,
  textRight: ?string,
  icon: string,
  link: boolean,
  url: string,
  button: boolean,
  buttonText: string,
  buttonDisabled: boolean,
};

export default class ListRow extends React.Component<TypeListRow> {
  static defaultProps = {
    text: null,
    textRight: null,
    icon: '#icon-calibration-certificate',
    link: false,
    url: '',
    button: false,
    buttonText: 'View',
    buttonDisabled: false,
  };

  render(): React.Element<*> {
    return (
      <ListItem button={false}>
        {this.props.text && <ListItemText className={styles.text} primary={this.props.text} />}
        {this.props.textMiddle && (
          <ListItemText className={styles.textMiddle} primary={this.props.textMiddle} />
        )}
        {this.props.textRight && (
          <ListItemText className={styles.textRight} primary={this.props.textRight} />
        )}
        {this.props.button && (
          <Button
            className={styles.button}
            color="primary"
            variant="contained"
            component={this.props.link ? Link : null}
            disabled={this.props.buttonDisabled}
            to={this.props.url}
          >
            {this.props.buttonText}
          </Button>
        )}
      </ListItem>
    );
  }
}
